export enum ClaimCategoryIconEnum {
    Car = 'car',
    Home = 'house',
    Travel = 'travel',
    Liability = 'liability',
    Motor = 'motorcycle',
    Moped = 'moped',
    Bicycle = 'bicycle',
    LegalAssistance = 'legal',
    Caravan = 'caravan',
    Pet = 'pet',
    Accident = 'accident',
}
